import { formatVnd, formatVnDateTime } from '@ruby-cms/shared';
import { soNguyen } from './soNguyen';

// The game wallet ("vin" in the game code) is shown to operators as won: 1 vin = 1 KRW.
export const CURRENCY = { code: 'KRW', symbol: '₩' } as const;

// unit: true = the KRW symbol, 'xu' = the separate play currency
export function Money({ v, signed = false, unit = false }: { v: string | number | bigint | null | undefined; signed?: boolean; unit?: boolean | 'xu' }) {
  if (v === null || v === undefined || v === '') return <span className="muted">-</span>;
  const n = soNguyen(v);
  if (n === null) return <span className="muted">{String(v)}</span>;
  const cls = signed ? (n > 0n ? 'num num--pos' : n < 0n ? 'num num--neg' : 'num') : 'num';
  if (unit !== true) return <span className={cls}>{signed && n > 0n ? '+' : ''}{formatVnd(n)}{unit === 'xu' ? ' xu' : ''}</span>;
  const sign = n < 0n ? '-' : signed && n > 0n ? '+' : '';
  return <span className={cls}>{sign}{CURRENCY.symbol}{formatVnd(n < 0n ? -n : n)}</span>;
}

export function When({ v }: { v: string | Date | number | null | undefined }) {
  if (v === null || v === undefined || v === '') return <span className="muted">-</span>;
  const d = typeof v === 'number' ? new Date(v) : typeof v === 'string' && /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(v) ? new Date(v.replace(' ', 'T') + 'Z') : new Date(v);
  if (Number.isNaN(d.getTime())) return <span className="muted">{String(v)}</span>;
  return <span className="num">{formatVnDateTime(d)}</span>;
}

export const shortId = (id: string) => id.slice(0, 8);

// 1.234.567.890 -> "1,23 tỷ", 12.400.000 -> "12,4 tr"; exact values stay in tables
export function compactVnd(v: bigint | string | number): string {
  const n = Number(v);
  const a = Math.abs(n);
  const f = (x: number, u: string) => {
    const s = x >= 100 ? x.toFixed(0) : x >= 10 ? x.toFixed(1) : x.toFixed(2);
    return (s.includes('.') ? s.replace(/\.?0+$/, '') : s).replace('.', ',') + ' ' + u;
  };
  const s = a >= 1e9 ? f(a / 1e9, 'tỷ') : a >= 1e6 ? f(a / 1e6, 'tr') : a >= 1e3 ? f(a / 1e3, 'k') : String(a);
  return (n < 0 ? '-' : '') + s;
}

export function Pct({ num, den }: { num: string | bigint; den: string | bigint }) {
  const d = Number(den);
  if (!d) return <span className="muted">-</span>;
  const p = (Number(num) / d) * 100;
  return <span className={'num' + (p < 0 ? ' num--neg' : '')}>{p.toFixed(1).replace('.', ',')}%</span>;
}
